import React from "react";

export type V2sContextValue = {
  allV2Ids: number[];
  fetchAllV2s: () => void;
  isLoading: boolean;
};

const V2sContext = React.createContext<V2sContextValue>({
  allV2Ids: [],
  fetchAllV2s: () => {},
  isLoading: false,
});

export default V2sContext;
